import { gql } from '@apollo/client';

export const ASSIGN_LOCATION_PERSON_MUTATION = gql(
  `mutation AssignLocationPersonMutation(  $locationId:UUID!,$personIds: [UUID!]!){
        assignLocationPersons(
        input:{ locationId: $locationId,personIds: $personIds}){
          location {
            id
            totalStaff
          }
        }
    }
    `
)

export const ASSIGN_PERSON_LOCATIONS_MUTATION = gql(
  `mutation AssignPersonLocationsMutation($personId:UUID!,$locationIds: [UUID!]!){
        assignPersonLocations(
        input:{ personId: $personId,locationIds: $locationIds}){
          person {
            id
            
          }
        }
    }
    `
)